<script lang="ts">
	import type { ISbRichtext, ISbStoryData } from '@storyblok/js';
	import { editable } from '../editable';
	import EmailModal from '../parts/emailModal.svelte';
	import SbRichtext from '../components/sbRichtext.svelte';
	import Blok from '../blok.svelte';
	import Mill from '$lib/logos/mill.svelte';
	import type ImageBlock from './imageBlock.svelte';
	import type { SbImage } from '../types';

	interface Props {
		content: ISbStoryData<{
			image: Array<ISbStoryData<ImageBlock | { asset: SbImage }>>;
			is_bg_image: boolean;
			title: ISbRichtext;
			subtitle: ISbRichtext;
			button: Array<ISbStoryData>;
			open_delay: number;
		}>['content'];
	}

	let { content }: Props = $props();

	let { image, is_bg_image, title, subtitle, button } = content;
</script>

<EmailModal
	openDelay={content.open_delay}
	title={content.title}
	text={content.subtitle}
	size="small"
>
	<div
		class={[
			'flex items-center justify-between px-5 pb-5 pt-6 lg:px-8 lg:pb-8',
			{ 'lg:hidden': is_bg_image }
		]}
	>
		<Mill class="h-6 text-green-3" />
	</div>
	<section
		use:editable={content}
		class={[
			'relative h-full text-balance px-5 text-center text-brown-1 lg:px-8 lg:text-[#001A10]',
			{ 'flex flex-col justify-center lg:py-40': is_bg_image }
		]}
	>
		{#if is_bg_image}
			<div class="absolute inset-0 z-0">
				{#each image as blok}
					<Blok content={blok} />
				{/each}
			</div>
		{:else}
			<div class="aspect-3/2 w-full pb-7 lg:aspect-video lg:pb-8">
				{#each image as blok}
					<div class="overflow-hidden rounded-xl">
						<Blok content={blok} />
					</div>
				{/each}
			</div>
		{/if}

		<div class="relative z-10 mb-7">
			<div
				class={{
					'mb-6 text-[60px]/[100%] tracking-[-1.2px]': is_bg_image,
					'mb-5 text-[44px]/[100%] tracking-[-.88px] lg:text-[48px]/[100%] lg:tracking-[-.96px]':
						!is_bg_image
				}}
			>
				<SbRichtext text={title} />
			</div>
			<div
				class={[
					'text-[14px]/[160%] lg:text-[16px]/[150%]',
					{ 'mb-7': is_bg_image, 'mb-5 lg:mb-6': !is_bg_image }
				]}
			>
				<SbRichtext text={subtitle} />
			</div>

			{#each button as blok}
				<Blok content={blok} />
			{/each}
		</div>
	</section>
</EmailModal>

<style lang="scss">
	div.modal-legal-text {
		:global(a) {
			text-decoration: underline;
		}

		:global(.font-rhymes) {
			font-family: 'Rhymes';
		}
	}
</style>
